import { mall_get_store, mall_set_store } from "@/util/store";
import { mall_wx_get_user_info } from "@/api/login";
import { get_default_address } from "@/api/user";
import { MallModules } from "@/api/constant";
import { api_get_goods_by_id, getJdVopGoodsStock } from "@/api/goods-api";
import store from "@/store";
import { Toast } from "vant";

const user = {
    state: {
        userInfo: mall_get_store({ name: 'userInfo' }) || {},
        expires_in: mall_get_store({ name: 'expires_in' }) || '',
        access_token: mall_get_store({ name: 'access_token' }) || '',
        refresh_token: mall_get_store({ name: 'refresh_token' }) || '',
        cart: mall_get_store({ name: 'cart' }) || [],
        city_code: mall_get_store({ name: 'city_code' }),
        address: mall_get_store({ name: 'address' }) || {},
        city_name: mall_get_store({ name: 'city_name' }) || '成都市',
        visibleTabBar: mall_get_store({ name: 'visible_tabbar' }) || true,
        mall_module: mall_get_store({ name: 'mall_module' }) || MallModules.mall
    },

    actions: {
        GetDefaultAddress({ commit }) {
            return new Promise(((resolve, reject) => {
                mall_wx_get_user_info().then(() => {
                    get_default_address().then(data => {
                        commit('SET_DEFAULT_ADDRESS', data.data)
                        resolve()
                    }).catch(error => {
                        reject(error)
                    })
                })
            }))
        },

        // 查询用户信息
        store_get_user_info({ commit }) {
            return new Promise((resolve, reject) => {
                mall_wx_get_user_info().then((res) => {
                    const data = res.data || {}
                    commit('SET_USER_INFO', data)
                    resolve(data)
                }).catch(() => {
                    reject()
                })
            })
        },

        updateCartCount({ commit }, goods) {
            return new Promise((resolve, reject) => {
                api_get_goods_by_id(goods.goodsId).then(res1 => {
                    const goodsInfoRes = res1.data;
                    const vop_supplier_id = 186;
                    const add = store.getters.address;
                    if (add && add.addressId && add.addressId > 0) {

                        if (goodsInfoRes.supplierId === vop_supplier_id) {
                            const goodsInfo = store.getters.cart.find(g => g.goods.goodsId === goods.goodsId);
                            budo_log.info('#115 goodsInfo=', goodsInfo)
                            let quantity = 0;
                            if (goodsInfo) {
                                quantity = goodsInfo.count;
                            }

                            if (quantity > 0) {
                                getJdVopGoodsStock(goods.goodsId, quantity, add.addressId).then(res2 => {
                                    if (res2.code === 0 && res2.data === 1) {
                                        commit("COUNT_CART", {
                                            goodsId: goods.goodsId,
                                            count: goods.count,
                                            spec: goods.spec,
                                        });
                                        resolve();
                                    } else {
                                        Toast.fail({ duration: 3000, message: '商品库存在当前区域不足，无法购买 B' });
                                        goodsInfo.checked = false;
                                        commit("COUNT_CART", {
                                            goodsId: goods.goodsId,
                                            count: goods.count,
                                            spec: goods.spec,
                                        });
                                    }
                                })
                            }
                        } else {
                            commit("COUNT_CART", {
                                goodsId: goods.goodsId,
                                count: goods.count,
                                spec: goods.spec,
                            });
                        }
                    } else {
                        Toast.fail({
                            duration: 5000,
                            message: '请点击商品图片设置收货地址 A'
                        });
                    }
                    resolve();
                })
            })
        }
    },

    mutations: {
        SET_ACCESS_TOKEN: (state, access_token) => {
            state.access_token = access_token
            mall_set_store({
                name: 'access_token',
                content: state.access_token,
                type: 'session'
            })
        },

        SET_DEFAULT_ADDRESS: (state, address) => {
            state.address = address
            mall_set_store({
                name: 'address',
                content: address,
                type: 'session'
            })
        },

        SET_EXPIRES_IN: (state, expires_in) => {
            state.expires_in = expires_in
            mall_set_store({
                name: 'expires_in',
                content: state.expires_in,
                type: 'session'
            })
        },

        SET_REFRESH_TOKEN: (state, rfToken) => {
            state.refresh_token = rfToken
            mall_set_store({
                name: 'refresh_token',
                content: state.refresh_token,
                type: 'session'
            })
        },

        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
            mall_set_store({
                name: 'userInfo',
                content: userInfo,
                type: 'session'
            })
        },

        SET_CART: (state, cartInfo) => {
            if (!cartInfo) {
                return
            }

            cartInfo.forEach(item => {
                let goods = state.cart.find(ary => ary.goods.goodsId === item.goods.goodsId)
                if (item.goods.spec && Array.isArray(item.goods.spec)) {
                    goods = state.cart.find(ary => ary.goods.goodsId === item.goods.goodsId
                        && (ary.goods.spec.sort().toString() === item.goods.spec.sort().toString()))
                }

                if (goods) {
                    goods.count += item.count;
                    goods.goods = {
                        ...goods.goods,
                        cateCode: item.goods.cateCode,
                    }
                } else {
                    state.cart.push(item)
                }
            })

            mall_set_store({
                name: 'cart',
                content: state.cart
            })
        },

        CLEAR_CART: (state) => {
            state.cart = []
            mall_set_store({
                name: 'cart',
                content: [],
                type: 'session'
            })
        },

        COUNT_CART: (state, cartInfo) => {
            let goods = state.cart.find(ary => ary.goods.goodsId === cartInfo.goodsId)
            if (cartInfo.spec && Array.isArray(cartInfo.spec)) {
                goods = state.cart.find(ary => ary.goods.goodsId === cartInfo.goodsId
                    && (ary.goods.spec.sort().toString() === cartInfo.spec.sort().toString()))
            }
            if (goods) {
                goods.count = cartInfo.count;
            }

            if (goods.count < 0) {
                goods.count = 0;
            }

            mall_set_store({
                name: 'cart',
                content: state.cart,
                type: 'session'
            })
        },

        SET_CITY_CODE: (state, cityCode) => {
            state.city_code = cityCode
            mall_set_store({
                name: 'city_code',
                content: cityCode,
                type: 'session'
            })
        },

        SET_CITY_NAME: (state, cityName) => {
            budo_log.debug("#249 mall user SET_CITY_NAME", state, cityName)

            state.city_name = cityName
            mall_set_store({
                name: 'city_name',
                content: cityName,
                type: 'session'
            })
        },

        SET_VISIBLE_TABBAR: (state, visibleTabBar) => {
            state.visibleTabBar = visibleTabBar
            mall_set_store({
                name: 'visible_tabbar',
                content: visibleTabBar,
                type: 'session'
            })
        },

        SET_MALL_MODULE: (state, moduleInfo) => {
            state.mall_module = moduleInfo;
            mall_set_store({
                name: 'mall_module',
                content: moduleInfo,
                type: 'session'
            })
        }
    }
}

export default user
